// extracted by mini-css-extract-plugin
export default {"button":"_fd87bb93","enterFromBottom":"_bace02d4","chatIcon":"_95ce5250","chatLabel":"_e5d6677d","container":"_64869042","withLiveChat":"_b61de68f"};